function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Icon_awesome-file-pdf",
  "data-name": "Icon awesome-file-pdf",
  d: "M11.61,12a3.66,3.66,0,0,1-.08-1.83C11.86,10.17,11.82,11.61,11.61,12Zm-.07,1.85a18.58,18.58,0,0,1-1.11,2.45,14.06,14.06,0,0,1,2.46-.86A4.92,4.92,0,0,1,11.54,13.85ZM7.86,18.72s.52-.21,1.37-1.57A5.28,5.28,0,0,0,7.86,18.72ZM14.19,8.25H19.5V21.06a.94.94,0,0,1-.93.94H5.44a.94.94,0,0,1-.94-.93h0V2.94A.94.94,0,0,1,5.43,2h7.82V7.31A.94.94,0,0,0,14.19,8.25ZM13.88,15a3.9,3.9,0,0,1-1.67-2.1,5.62,5.62,0,0,0,.24-2.51,1,1,0,0,0-1.87-.26,6.51,6.51,0,0,0,.32,3,36.92,36.92,0,0,1-1.6,3.36h0C8.24,17,6.43,18.18,7.17,19.1a1.19,1.19,0,0,0,.84.39c.7,0,1.39-.7,2.39-2.41a21.79,21.79,0,0,1,3.08-.91,5.83,5.83,0,0,0,2.5.76,1,1,0,0,0,1-1,1,1,0,0,0-.27-.7c-.54-.53-2.12-.38-2.87-.28ZM19.23,6.1,15.4,2.27A1,1,0,0,0,14.73,2H14.5V7h5V6.76A1,1,0,0,0,19.23,6.1Zm-2.9,10c.16-.1-.1-.46-1.67-.35C16.11,16.34,16.33,16.07,16.33,16.07Z"
});

var SvgIconPdf = function SvgIconPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_34",
    "data-name": "Layer 34",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pdf.68d34d38.svg";
export { ForwardRef as ReactComponent };